import './style.scss';
import { DatePicker } from 'antd';
import moment from 'moment';
import { Moment } from 'moment';
import { InsuranceFilter } from '../../insurance-results-page';

interface IProps {
  label: string;
  icon: any;
  setInsuranceFilter: React.Dispatch<React.SetStateAction<any>>;
  insuranceFilter: InsuranceFilter;
}

export default function InsuranceDatesFilter(props: IProps) {
  const { label, icon, insuranceFilter, setInsuranceFilter } = props;
  const { RangePicker } = DatePicker;

  const onChange = (dates: [Moment | null, Moment | null] | null) => {
    setInsuranceFilter((prevState: any) => ({
      ...prevState,
      travelDates: dates,
    }));
  };

  const disablePastDates = (current: moment.Moment) => {
    // Disabled the day before tomorrow
    return current ? current.isBefore(moment().add(1, 'day').startOf('day')) : false;
  };


  return (
    <div className="insurance-filters-containers">
      <div className="insurance-filters-containers-icons">
        <img src={icon} className="search-container-icons" />
      </div>
      <div className="insurance-filters-containers-inputs">
        <div className="insurance-filters-containers-inputs-title">
          <span>{label}</span>
        </div>
        <RangePicker
          className="insurance-filters-containers-inputs-controls"
          style={{ background: 'rgb(245,245,246)', border: 'none', boxShadow: 'none' }}
          onChange={onChange}
          value={insuranceFilter?.travelDates as any}
          popupClassName="custom-insurance-dates-dropdown"
          disabledDate={disablePastDates}
        />
      </div>
    </div>
  );
}
